import React, { Fragment } from 'react'
import Modal from '../modal'
import { MdClose } from 'react-icons/md'
import 'styled-components/macro'
import { styled } from 'styled-components'
import { ImageWithZoom } from '../../assets/styles'
import OptionalMarkdown from '../Markdown/OptionalMarkdown'
import { _tempTheme } from '../../utils/tempTheme'

interface ModalImageProps {
	url?: string
	setClose: () => void
	isOpen: boolean
	minimal?: boolean
	text?: string
	fullScreen?: boolean
	infoText?: string
	style?: any
	parentSelector?: HTMLElement
}

// Modal that's showing the single image on a full screen
export const ImageModal = ({
	url,
	setClose,
	isOpen,
	minimal = false,
	fullScreen = false,
	text,
	infoText,
	...rest
}: ModalImageProps): JSX.Element => {
	const image = (
		<div css="width: fit-content; justify-content: center; display: flex; text-align: center; margin: auto;">
			<img src={url} alt="preview" css="max-width: 100%; height: auto;" />
		</div>
	)
	return isOpen ? (
		<Modal
			isOpen={isOpen}
			overlayClassName="z-[1000]"
			className={
				fullScreen
					? 'inset-10 bg-transparent border-0 max-w-full'
					: 'absolute top-12 left-2/4 right-auto bottom-auto -translate-x-2/4 block translate-y-0 bg-white h-fit max-h-[80vh] overflow-auto shadow p-0 w-fit outline-none'
			}
			onClose={setClose}
			closeButton={false}
			lightTheme={!fullScreen}
			{...rest}>
			{fullScreen ? (
				<div
					onClick={setClose}
					css="margin: auto; display: flex; height: 100%; width: 100%;">
					<ImageWithZoom alt="Image" src={url} />
				</div>
			) : minimal ? (
				image
			) : (
				<>
					<ModalHeader>
						<TextContainer>
							<p className="title">{infoText} </p>
							<span className="paragraph">
								{text ? (
									<OptionalMarkdown>{text}</OptionalMarkdown>
								) : (
									'(No Text)'
								)}
							</span>
						</TextContainer>
						<MdClose
							style={{ cursor: 'pointer', transform: 'scale(1.3)' }}
							onClick={() => setClose()}
						/>
					</ModalHeader>
					<ModalImageContainer>{image}</ModalImageContainer>
				</>
			)}
		</Modal>
	) : (
		<Fragment />
	)
}

const ModalHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: start;

	${({ theme }) => `
		background-color: ${theme.base};
		padding: ${_tempTheme.spacing4};
		color: ${theme.onBase};
		font-size: ${_tempTheme.text_base};
		font-weight: ${_tempTheme.font_semibold};
	`}
	.title {
		font-size: 10px;
		margin-bottom: 0.5rem;
		line-height: 15px;
	}
	.paragraph {
		font-size: ${_tempTheme.text_base};
		line-height: ${_tempTheme.text_2xl};
	}
`

const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	p {
		font-size: 10px;
		margin-bottom: 0.5rem;
	}
`

const ModalImageContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: ${_tempTheme.spacing4};

	img {
		width: auto;
		max-width: 80%;
		max-height: 100%;
		object-fit: contain;
	}
`

export default ImageModal
